import {RECEIVE_PROCUREMENTS} from '../actions'

const procurementsReducer = (state=[], action) => {
	switch(action.type) {
		case RECEIVE_PROCUREMENTS:
			return action.procurements;
		default:
			return state;
	}
}

export default procurementsReducer


// WEBPACK FOOTER //
// ./src/reducers/ProcurementsReducer.js